import { bindable, autoinject } from "aurelia-framework";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { DialogServiceConstants } from "../../../constants/basics/dialog.constants";

@autoinject
export class IconPicker {

    @bindable
    icon: string;

    constructor(private dialogClientService: DialogClientService) { }

    openIconPickerDialog() {
        this.dialogClientService.show(DialogServiceConstants.URLs.IconPickerDialog, { onPick: this.onPick });
    }

    public onPick = (icon: string) => {
        this.icon = icon;
        this.dialogClientService.hide();
    }
}